"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: feature-store/payment-features.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ffeature-store%2Fpayment-features.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationLevelToJSON = exports.aggregationLevelFromJSON = exports.rollingWindowToJSON = exports.rollingWindowFromJSON = exports.BasicStats = exports.RollingCardPurchaseFeatures = exports.RollingFundingFeatures = exports.RollingPaymentFeatures = exports.AggregationLevel = exports.RollingWindow = void 0;
const protobufPackage = 'com.step.featurestore.internal.proto';
/**
 * Number of previous days to include in the rolling features computation.
 */
var RollingWindow;
(function (RollingWindow) {
    RollingWindow["INVALID_ROLLING_WINDOW"] = "INVALID_ROLLING_WINDOW";
    RollingWindow["ONE_DAY"] = "ONE_DAY";
    RollingWindow["SEVEN_DAYS"] = "SEVEN_DAYS";
    RollingWindow["THIRTY_DAYS"] = "THIRTY_DAYS";
    RollingWindow["UNRECOGNIZED"] = "UNRECOGNIZED";
})(RollingWindow || (exports.RollingWindow = RollingWindow = {}));
/**
 * Aggregation level of rolling features computation.
 */
var AggregationLevel;
(function (AggregationLevel) {
    AggregationLevel["INVALID_AGGREGATION_LEVEL"] = "INVALID_AGGREGATION_LEVEL";
    AggregationLevel["USER"] = "USER";
    AggregationLevel["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AggregationLevel || (exports.AggregationLevel = AggregationLevel = {}));
function createBaseRollingPaymentFeatures() {
    return { rollingFundingFeatures: [], rollingCardPurchaseFeatures: [] };
}
exports.RollingPaymentFeatures = {
    fromJSON(object) {
        const message = {
            rollingFundingFeatures: globalThis.Array.isArray(object?.rollingFundingFeatures)
                ? object.rollingFundingFeatures.map((e) => exports.RollingFundingFeatures.fromJSON(e))
                : [],
            rollingCardPurchaseFeatures: globalThis.Array.isArray(object?.rollingCardPurchaseFeatures)
                ? object.rollingCardPurchaseFeatures.map((e) => exports.RollingCardPurchaseFeatures.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rollingFundingFeatures?.length) {
            obj.rollingFundingFeatures = message.rollingFundingFeatures.map((e) => exports.RollingFundingFeatures.toJSON(e));
        }
        if (message.rollingCardPurchaseFeatures?.length) {
            obj.rollingCardPurchaseFeatures = message.rollingCardPurchaseFeatures.map((e) => exports.RollingCardPurchaseFeatures.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.RollingPaymentFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRollingPaymentFeatures();
        message.rollingFundingFeatures =
            object.rollingFundingFeatures?.map((e) => exports.RollingFundingFeatures.fromPartial(e)) || [];
        message.rollingCardPurchaseFeatures =
            object.rollingCardPurchaseFeatures?.map((e) => exports.RollingCardPurchaseFeatures.fromPartial(e)) ||
                [];
        return message;
    },
};
function createBaseRollingFundingFeatures() {
    return {
        aggregationLevel: AggregationLevel.INVALID_AGGREGATION_LEVEL,
        window: RollingWindow.INVALID_ROLLING_WINDOW,
        committedAmountStats: undefined,
        declinedCount: 0,
        riskyDebitCount: 0,
        stripeRiskScoreStats: undefined,
        cardZipToIpDistanceStats: undefined,
        cardZipToKycDistanceStats: undefined,
        kycToIpDistanceStats: undefined,
    };
}
exports.RollingFundingFeatures = {
    fromJSON(object) {
        const message = {
            aggregationLevel: isSet(object.aggregationLevel)
                ? aggregationLevelFromJSON(object.aggregationLevel)
                : AggregationLevel.INVALID_AGGREGATION_LEVEL,
            window: isSet(object.window)
                ? rollingWindowFromJSON(object.window)
                : RollingWindow.INVALID_ROLLING_WINDOW,
        };
        if (isSet(object.committedAmountStats)) {
            message.committedAmountStats = exports.BasicStats.fromJSON(object.committedAmountStats);
        }
        if (isSet(object.declinedCount)) {
            message.declinedCount = globalThis.Number(object.declinedCount);
        }
        if (isSet(object.riskyDebitCount)) {
            message.riskyDebitCount = globalThis.Number(object.riskyDebitCount);
        }
        if (isSet(object.stripeRiskScoreStats)) {
            message.stripeRiskScoreStats = exports.BasicStats.fromJSON(object.stripeRiskScoreStats);
        }
        if (isSet(object.cardZipToIpDistanceStats)) {
            message.cardZipToIpDistanceStats = exports.BasicStats.fromJSON(object.cardZipToIpDistanceStats);
        }
        if (isSet(object.cardZipToKycDistanceStats)) {
            message.cardZipToKycDistanceStats = exports.BasicStats.fromJSON(object.cardZipToKycDistanceStats);
        }
        if (isSet(object.kycToIpDistanceStats)) {
            message.kycToIpDistanceStats = exports.BasicStats.fromJSON(object.kycToIpDistanceStats);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.aggregationLevel !== AggregationLevel.INVALID_AGGREGATION_LEVEL) {
            obj.aggregationLevel = aggregationLevelToJSON(message.aggregationLevel);
        }
        if (message.window !== RollingWindow.INVALID_ROLLING_WINDOW) {
            obj.window = rollingWindowToJSON(message.window);
        }
        if (message.committedAmountStats !== undefined) {
            obj.committedAmountStats = exports.BasicStats.toJSON(message.committedAmountStats);
        }
        if (message.declinedCount !== undefined && message.declinedCount !== 0) {
            obj.declinedCount = Math.round(message.declinedCount);
        }
        if (message.riskyDebitCount !== undefined && message.riskyDebitCount !== 0) {
            obj.riskyDebitCount = Math.round(message.riskyDebitCount);
        }
        if (message.stripeRiskScoreStats !== undefined) {
            obj.stripeRiskScoreStats = exports.BasicStats.toJSON(message.stripeRiskScoreStats);
        }
        if (message.cardZipToIpDistanceStats !== undefined) {
            obj.cardZipToIpDistanceStats = exports.BasicStats.toJSON(message.cardZipToIpDistanceStats);
        }
        if (message.cardZipToKycDistanceStats !== undefined) {
            obj.cardZipToKycDistanceStats = exports.BasicStats.toJSON(message.cardZipToKycDistanceStats);
        }
        if (message.kycToIpDistanceStats !== undefined) {
            obj.kycToIpDistanceStats = exports.BasicStats.toJSON(message.kycToIpDistanceStats);
        }
        return obj;
    },
    create(base) {
        return exports.RollingFundingFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRollingFundingFeatures();
        message.aggregationLevel = object.aggregationLevel ??
            AggregationLevel.INVALID_AGGREGATION_LEVEL;
        message.window = object.window ?? RollingWindow.INVALID_ROLLING_WINDOW;
        message.committedAmountStats =
            (object.committedAmountStats !== undefined && object.committedAmountStats !== null)
                ? exports.BasicStats.fromPartial(object.committedAmountStats)
                : undefined;
        message.declinedCount = object.declinedCount ?? 0;
        message.riskyDebitCount = object.riskyDebitCount ?? 0;
        message.stripeRiskScoreStats =
            (object.stripeRiskScoreStats !== undefined && object.stripeRiskScoreStats !== null)
                ? exports.BasicStats.fromPartial(object.stripeRiskScoreStats)
                : undefined;
        message.cardZipToIpDistanceStats =
            (object.cardZipToIpDistanceStats !== undefined && object.cardZipToIpDistanceStats !== null)
                ? exports.BasicStats.fromPartial(object.cardZipToIpDistanceStats)
                : undefined;
        message.cardZipToKycDistanceStats =
            (object.cardZipToKycDistanceStats !== undefined && object.cardZipToKycDistanceStats !== null)
                ? exports.BasicStats.fromPartial(object.cardZipToKycDistanceStats)
                : undefined;
        message.kycToIpDistanceStats =
            (object.kycToIpDistanceStats !== undefined && object.kycToIpDistanceStats !== null)
                ? exports.BasicStats.fromPartial(object.kycToIpDistanceStats)
                : undefined;
        return message;
    },
};
function createBaseRollingCardPurchaseFeatures() {
    return {
        aggregationLevel: AggregationLevel.INVALID_AGGREGATION_LEVEL,
        window: RollingWindow.INVALID_ROLLING_WINDOW,
        committedAmountStats: undefined,
        declinedCount: 0,
        refundedCount: 0,
        refundedAmount: 0,
    };
}
exports.RollingCardPurchaseFeatures = {
    fromJSON(object) {
        const message = {
            aggregationLevel: isSet(object.aggregationLevel)
                ? aggregationLevelFromJSON(object.aggregationLevel)
                : AggregationLevel.INVALID_AGGREGATION_LEVEL,
            window: isSet(object.window)
                ? rollingWindowFromJSON(object.window)
                : RollingWindow.INVALID_ROLLING_WINDOW,
        };
        if (isSet(object.committedAmountStats)) {
            message.committedAmountStats = exports.BasicStats.fromJSON(object.committedAmountStats);
        }
        if (isSet(object.declinedCount)) {
            message.declinedCount = globalThis.Number(object.declinedCount);
        }
        if (isSet(object.refundedCount)) {
            message.refundedCount = globalThis.Number(object.refundedCount);
        }
        if (isSet(object.refundedAmount)) {
            message.refundedAmount = globalThis.Number(object.refundedAmount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.aggregationLevel !== AggregationLevel.INVALID_AGGREGATION_LEVEL) {
            obj.aggregationLevel = aggregationLevelToJSON(message.aggregationLevel);
        }
        if (message.window !== RollingWindow.INVALID_ROLLING_WINDOW) {
            obj.window = rollingWindowToJSON(message.window);
        }
        if (message.committedAmountStats !== undefined) {
            obj.committedAmountStats = exports.BasicStats.toJSON(message.committedAmountStats);
        }
        if (message.declinedCount !== undefined && message.declinedCount !== 0) {
            obj.declinedCount = Math.round(message.declinedCount);
        }
        if (message.refundedCount !== undefined && message.refundedCount !== 0) {
            obj.refundedCount = Math.round(message.refundedCount);
        }
        if (message.refundedAmount !== undefined && message.refundedAmount !== 0) {
            obj.refundedAmount = message.refundedAmount;
        }
        return obj;
    },
    create(base) {
        return exports.RollingCardPurchaseFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRollingCardPurchaseFeatures();
        message.aggregationLevel = object.aggregationLevel ??
            AggregationLevel.INVALID_AGGREGATION_LEVEL;
        message.window = object.window ?? RollingWindow.INVALID_ROLLING_WINDOW;
        message.committedAmountStats =
            (object.committedAmountStats !== undefined && object.committedAmountStats !== null)
                ? exports.BasicStats.fromPartial(object.committedAmountStats)
                : undefined;
        message.declinedCount = object.declinedCount ?? 0;
        message.refundedCount = object.refundedCount ?? 0;
        message.refundedAmount = object.refundedAmount ?? 0;
        return message;
    },
};
function createBaseBasicStats() {
    return { sum: 0, avg: 0, variance: 0, max: 0, count: 0 };
}
exports.BasicStats = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.sum)) {
            message.sum = globalThis.Number(object.sum);
        }
        if (isSet(object.avg)) {
            message.avg = globalThis.Number(object.avg);
        }
        if (isSet(object.variance)) {
            message.variance = globalThis.Number(object.variance);
        }
        if (isSet(object.max)) {
            message.max = globalThis.Number(object.max);
        }
        if (isSet(object.count)) {
            message.count = globalThis.Number(object.count);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sum !== undefined && message.sum !== 0) {
            obj.sum = message.sum;
        }
        if (message.avg !== undefined && message.avg !== 0) {
            obj.avg = message.avg;
        }
        if (message.variance !== undefined && message.variance !== 0) {
            obj.variance = message.variance;
        }
        if (message.max !== undefined && message.max !== 0) {
            obj.max = message.max;
        }
        if (message.count !== undefined && message.count !== 0) {
            obj.count = Math.round(message.count);
        }
        return obj;
    },
    create(base) {
        return exports.BasicStats.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBasicStats();
        message.sum = object.sum ?? 0;
        message.avg = object.avg ?? 0;
        message.variance = object.variance ?? 0;
        message.max = object.max ?? 0;
        message.count = object.count ?? 0;
        return message;
    },
};
function rollingWindowFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ROLLING_WINDOW':
            return RollingWindow.INVALID_ROLLING_WINDOW;
        case 1:
        case 'ONE_DAY':
            return RollingWindow.ONE_DAY;
        case 2:
        case 'SEVEN_DAYS':
            return RollingWindow.SEVEN_DAYS;
        case 3:
        case 'THIRTY_DAYS':
            return RollingWindow.THIRTY_DAYS;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return RollingWindow.UNRECOGNIZED;
    }
}
exports.rollingWindowFromJSON = rollingWindowFromJSON;
function rollingWindowToJSON(object) {
    switch (object) {
        case RollingWindow.INVALID_ROLLING_WINDOW:
            return 'INVALID_ROLLING_WINDOW';
        case RollingWindow.ONE_DAY:
            return 'ONE_DAY';
        case RollingWindow.SEVEN_DAYS:
            return 'SEVEN_DAYS';
        case RollingWindow.THIRTY_DAYS:
            return 'THIRTY_DAYS';
        case RollingWindow.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.rollingWindowToJSON = rollingWindowToJSON;
function aggregationLevelFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_AGGREGATION_LEVEL':
            return AggregationLevel.INVALID_AGGREGATION_LEVEL;
        case 1:
        case 'USER':
            return AggregationLevel.USER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AggregationLevel.UNRECOGNIZED;
    }
}
exports.aggregationLevelFromJSON = aggregationLevelFromJSON;
function aggregationLevelToJSON(object) {
    switch (object) {
        case AggregationLevel.INVALID_AGGREGATION_LEVEL:
            return 'INVALID_AGGREGATION_LEVEL';
        case AggregationLevel.USER:
            return 'USER';
        case AggregationLevel.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.aggregationLevelToJSON = aggregationLevelToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-features.js.map